<div class="flex flex-wrap">
  <div *ngFor="let filter of technicianFilter | keys" class="mr-2 mb-2">
    <p-chip [label]="getLabel(filter)" [removable]="true" (onRemove)="onRemoveFilter(filter.key)">
    </p-chip>
  </div>
</div>
